commusoftCommon.filter('capitalize', function() {
    return function(input, scope) {
        if(!angular.isString(input)){
            return input;
        }
        if (input!=null) {
            return input.substring(0,1).toUpperCase()+input.substring(1);
        }
    }
});